export default __webpack_public_path__ + "tab4_video_poster_m717643.png";